import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { MedicalEventsDocumentsModal } from './MedicalEventsDocumentsModal.component'

const withUnmountingHoc = withUnmountTransition(MedicalEventsDocumentsModal)

export { withUnmountingHoc as MedicalEventsDocumentsModal }
